import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';

export const DatePickerContainer = styled.div`
  .react-datepicker-popper {
    z-index: 10;
  }

  .react-datepicker__header {
    background-color: #fff;
    border-bottom: none;
  }

  .react-datepicker__input-container,
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: ${th('colors.turquoise')};
    border-radius: 50%;
  }
`;

export const StyledSelectedDate = styled.button`
  position: relative;
  width: 100%;
  padding: ${th('space.2')}px;
  border-radius: 4px;
  font-size: 16px;
  text-align: left;
  background-color: ${th('colors.white')};

  > :last-child {
    position: absolute;
    right: 10px;
    color: ${th('colors.silverGray')};
  }

  ${variants('variant', {
    light: css`
      border: none;
    `,
    dark: css`
      border: 1px solid ${th('colors.darkSlateGray')};
    `,
    blue: css`
      border: 1px solid ${th('colors.blue')};
      color: ${th('colors.blue')};
      > :last-child {
        color: ${th('colors.blue')};
      }
    `,
    turquoise: css`
      background-color: ${th('colors.dew')};
      border: 1px solid ${th('colors.turquoise')};
      color: ${th('colors.black')};
      ${({ isPlaceholder }) =>
        isPlaceholder &&
        css`
          color: ${th('colors.black')}80;
        `};
      > :last-child {
        color: ${th('colors.turquoise')};
      }
    `
  })}
`;

export const MonthHeader = styled.div`
  margin: ${th('space.1')}px ${th('space.2')}px;
  display: flex;
  justify-content: space-between;

  > button {
    background-color: transparent;
    font-size: 20px;
    cursor: pointer;
    border: none;

    :not(:disabled) {
      color: ${th('colors.black')};
    }
  }

  > select {
    font-size: 13px;
    color: ${th('colors.black')};
  }
`;
